<template>
  <div id="signup">
    <ValidationObserver v-slot="{ invalid, errors }" ref="validform">
      <form @submit.prevent="signup()">
        <main class="main reception card-sales-connect">
          <div class="section top">
            <div class="top__logo">
              <img src="../../assets/images/logo-logo-fundanow-bb.svg" alt="funda-now-logo" />
            </div>
          </div>
          <div class="section form-group">
            <div class="description">
              <h4>
                사장님의
                <strong>추가정보</strong>를 입력해주세요.
              </h4>
            </div>
            <div class="field-group name flex">
              <FormInput
                type="text"
                name="name"
                v-model="addtionalInfo.name"
                rules="required|co_kor"
                placeholder="성함을 입력해주세요."
              />
              <p
                v-if="errors.name != null && errors.name[0] != null"
                class="error-text"
              >{{errors.name[0]}}</p>
            </div>
            <div class="field-group phone flex">
              <FormInput
                type="tel"
                name="phone"
                style="flex: auto;"
                v-model="addtionalInfo.phone"
                @input="inputPhoneNum()"
                rules="required|numeric|phone"
                placeholder="전화번호를 입력해주세요."
              />
              <p
                v-if="errors.phone != null && errors.phone[0] != null"
                class="error-text"
              >{{errors.phone[0]}}</p>
            </div>
            <div class="field-group email flex">
              <FormInput
                type="text"
                name="email"
                rules="required|email"
                v-model="addtionalInfo.email"
                placeholder="이메일 주소를 입력해주세요."
              />
              <p
                v-if="errors.email != null && errors.email[0] != null"
                class="error-text"
              >{{errors.email[0]}}</p>
            </div>
          </div>
          <div>
            <button
              v-ripple
              type="submit"
              :disabled="invalid||isInProgress"
              class="button complete-button"
            >
              완료
              <v-progress-circular
                style="padding-left: 15px;"
                size="24"
                v-if="isInProgress"
                indeterminate
                color="primary"
              />
            </button>
          </div>
        </main>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import UserService from '@/service/user/UserService'
import AuthService from '@/service/auth/AuthService'
import PrefetchService from '@/service/auth/PrefetchService'
import userApi from '@/api/now/userApi'
import FormInput from '@/components/form/FormInput'

function isEmpty(v) {
  return !!(v == null || v.length === 0)
}

// Variable Section
let dataPrefetch // Original customer's data that is prefetched
let self

// Function Section
const checkKoreanName = function (name) {
  var pattern = /^[가-힣]{2,4}$/
  return pattern.test(name)
}

export default {
  components: {
    FormInput
  },
  data() {
    return {
      addtionalInfo: {
        name: null,
        email: null,
        phone: null
      },
      isInProgress: false
    }
  },
  destroyed() {
    this.$store.commit('ui/headerVisible', true)
  },
  async created() {
    this.$store.commit('ui/headerVisible', false)

    // Variable Section
    self = this
    let data = AuthService.getProfile()

    // Main Section
    // Prefetch
    let queryToken = PrefetchService.filterQuery(this.$route.query)
    if (queryToken) { // (ex) http://localhost:8080/signup?token=1234
      try {
        const response = await userApi.getPrefetchUser({ token: queryToken.token, 'field': 'user' }) // http://127.0.0.1:8000/api/prefetch/user/?token=1&field=user
        dataPrefetch = response.data
      } catch (e) {}
    }

    // Check data
    if (isEmpty(data.name) === false && isEmpty(data.phone) === false && isEmpty(data.email) === false) {
      if (!dataPrefetch) { // Normal process
        // this.$router.push({ name: 'dashboard' })
      }
    }

    // Set addtionalInfo
    self.addtionalInfo.name = ((data && checkKoreanName(data.name)) ? data.name : null) || ((dataPrefetch && checkKoreanName(dataPrefetch.name)) ? dataPrefetch.name : null)
    self.addtionalInfo.email = (data ? data.email : null) || (dataPrefetch ? dataPrefetch.email : null)
    self.addtionalInfo.phone = (data ? data.phone : null) || (dataPrefetch ? dataPrefetch.phone : null)
    self.inputPhoneNum()
  },
  mounted() {
    const checkForm = () => {
      if (!self.addtionalInfo) { return }
      if (!(self.addtionalInfo.name || self.addtionalInfo.email || self.addtionalInfo.phone)) { return }
      if (self.$refs && self.$refs.validform) self.$refs.validform.validate()
    }

    setTimeout(function () {
      checkForm()
    }, 500)
  },
  methods: {

    async signup() {
      if (this.isInProgress === true || this.$refs.validform.flags.invalid === true) {
        return
      }
      this.isInProgress = true
      try {
        // Update user
        await UserService.patchUser(this.addtionalInfo)

        // Go to next page
        if (dataPrefetch) { // Prefetch process
          this.$router.push({ name: 'cardsales/form', query: this.$route.query })
        } else { // Normal process
          this.$router.push({ name: 'dashboard' })
        }
      } catch (e) {
        console.error(e, 'signup')
        // e.data.phone[0] 사용자의 전화번호은/는 이미 존재합니다.
        if (e && e.data != null) {
          alert(e.data[Object.getOwnPropertyNames(e.data)[0]][0])
          if (e.data.phone != null && e.data.phone[0] === '사용자의 전화번호은/는 이미 존재합니다.') {
            this.$refs.validform.setErrors({
              phone: ['이미 등록되어 있는 전화번호입니다.']
            })
          }
        }
      } finally {
        this.isInProgress = false
      }
    },
    inputPhoneNum() {
      let phone = this.addtionalInfo.phone
      if (phone != null && phone.length > 0) {
        this.addtionalInfo.phone = phone.replace(/[^\d]/g, '')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  #signup {
  }
</style>
